<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-ministry-sidebar></app-ministry-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div class="card shadow m-3" style="width: 100%">
              <div
                class="
                  card-header
                  heading_n_button_box
                  card-header-cus-new-appoint
                "
              >
                <div class="card-heading">
                  <h4>Post Arrival COVID-19 PCR Test Defaulters</h4>
                </div>

                <div class="button-section mt-1"></div>
              </div>

              <div class="card-body">
                <div class="col-lg-12">
                  <div class="col-lg-12">
                    <form
                      [formGroup]="searchForm"
                      (ngSubmit)="onSubmitSearch(searchForm.value)"
                    >
                      <div class="form-row">
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="passengerName" placeholder="Passenger Name"
                            formControlName="passengerName"
                            id="passengerName"
                          > 
                        </div> 
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="passportNumber" placeholder="Passport Number"
                            formControlName="passportNumber"
                            id="passportNumber"
                          > 
                        </div> 
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="phone" placeholder="Phone Number"
                            formControlName="phone"
                            id="phone"
                          > 
                        </div> 
 

                        <div class="col">
                          <div class="mr-4">
                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                              "
                              type="submit"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fas fa-search"></i> Search
                            </button>

                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                                ml-2
                              "
                              type="button"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                              (click)="clearSearch()"
                            >
                              <i class="fas fa-sync-alt"></i> Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="">
                    <div class="table-responsive mt-3">
                      <div class="col-auto">
                        <div class="row" *ngIf="defaulters">
                          <div class="show-record mt-3 mbm-32">
                            <span>Show</span> &nbsp;
                            <select
                              class="
                                custom-select custom-select-sm
                                form-control form-control-sm
                              "
                              (change)="setItemsPerPage(page.value)"
                              #page
                            >
                              <option [selected]="currentPageLength == 10">
                                10
                              </option>
                              <option [selected]="currentPageLength == 30">
                                30
                              </option>
                              <option [selected]="currentPageLength == 50">
                                50
                              </option>
                              <option [selected]="currentPageLength == 100">
                                100
                              </option>
                              <option [selected]="currentPageLength == 500">
                                500
                              </option>
                              <option [selected]="currentPageLength == 1000">
                                1000
                              </option>
                            </select>
                            &nbsp;
                            <span> entries</span>
                          </div>
                        </div>
                      </div>

                      <table
                        *ngIf="defaulters"
                        class="
                          table
                          table-bordered
                          table-condensed
                          table-responsive-sm
                          table-responsive-md
                          table-responsive-lg
                          table-responsive-xl
                          nowrap
                        "
                        datatable
                        [dtOptions]="dtOptions"
                        width="100%"
                      >
                        <thead class="">
                          <tr>
                            <th scope="col">S/N</th>
                            <th scope="col">Passenger Name</th>
                            <th scope="col">Passport Number</th>
                            <th scope="col">Phone Number</th>
                            <th scope="col">Date Of Arrival</th>
                            <th scope="col">Scheduled Date For COVID-19 Test</th>
                            <th scope="col">Address</th>
                            <th scope="col">Number of Active Follow-ups</th>
                            <th scope="col">Nationality</th>
                            <th scope="col">Created At</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody class="dashboard-bg-white">
                          <tr
                            *ngFor="
                              let passenger of defaulters | paginate: config;
                              index as i
                            "
                          >
                            <th scope="row">
                              {{
                                config.itemsPerPage * (config.currentPage - 1) +
                                  i +
                                  1
                              }}
                            </th>
                            <td>
                              {{ passenger.first_name }}
                              {{ passenger.middle_name }}
                              {{ passenger.last_name }}
                            </td>
                            <td>{{ passenger.passport_no }}</td>
                            <td>{{ passenger.phone }}</td>
                            <td>
                              {{ passenger.arrival_date | date: "medium" }}
                            </td>
                            <td>
                              {{ passenger.booking_date | date: "medium" }}
                            </td>
                            <td>{{ passenger.address }}</td>
                            <td>{{ passenger.no_of_reminders || 'NA' }}</td>
                            <td>{{ passenger.nationality }}</td>
                            <td>{{ passenger.created_at | date: "medium" }}</td>

                            <td>
                             
                              <button
                              title="Send Email Reminder"
                              (click)="
                                sendEmailReminder(passenger)
                              "
                              class="btn-view"
                              type="button"
                            >
                              Send Email Reminder
                            </button>


                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="table-footer">
                        <div
                          id="page_info"
                          class="mt-3 record-show-text-bottom"
                          *ngIf="defaulters"
                        >
                          Showing
                          {{
                            (config.currentPage - 1) * config.itemsPerPage + 1
                          }}
                          - {{ config.currentPage * config.itemsPerPage }} of
                          {{ config.totalItems }} entries
                        </div>

                        <div
                          class="pagination paging-pull-right"
                          *ngIf="defaulters"
                        >
                          <pagination-controls
                            (pageChange)="pageChange($event)"
                            class="my-pagination mt-2 pagination-server"
                          >
                          </pagination-controls>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer-dashboard></app-footer-dashboard>
